import { render, staticRenderFns } from "./KeyFindingAnswer.vue?vue&type=template&id=b19bca10&scoped=true"
import script from "./KeyFindingAnswer.vue?vue&type=script&lang=ts"
export * from "./KeyFindingAnswer.vue?vue&type=script&lang=ts"
import style0 from "./KeyFindingAnswer.vue?vue&type=style&index=0&id=b19bca10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19bca10",
  null
  
)

export default component.exports